"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataKeys = void 0;
exports.ODataKeys = [
    "top",
    "select",
    "expand",
    "skip",
    "sort",
    "filter",
    "$top",
    "$select",
    "$expand",
    "$skip",
    "$sort",
    "$filter"
];
//# sourceMappingURL=OData.js.map